import * as Action from '../action';

export default (state = {}, action) => {
  switch (action.type) {
    case Action.ADD_ERP_PAYMENT_LOGS:
      return action.data;
    case Action.CLEAR_ERP_PAYMENT_LOGS:
      return {};
    default: return state;
  }
};
